/** Parsea un ISO datetime a instante absoluto; `null` si es ausente o no
 * parseable (nunca lanza — specs/019-estados-compra-eventos/research.md §4). */
function parseInstant(value: string | null): Date | null {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

/**
 * Comparación de **instantes absolutos**, no de días: `sale_end` es una
 * fecha-hora con offset y la venta cierra en un momento concreto, así que aquí
 * sí procede construir un `Date` (a diferencia de la fecha del espectáculo —
 * ver `isEventPast` en `lib/dates`, que compara días de calendario).
 */
export function isSaleEnded(saleEnd: string | null, now: Date = new Date()): boolean {
  const parsed = parseInstant(saleEnd)
  return parsed !== null && parsed < now
}
